import styled from 'styled-components';

export const AppWrapper = styled.div`
  background: ${({ theme }) => theme.colors.bodyBg};
  min-height: 100vh;
  width: 100%;
`;

export const PageContent = styled.main`
  max-width: ${({ theme }) => theme.layout.maxWidth};
  margin: 0 auto;
  padding: 6rem 1.5rem 3rem;

  @media (max-width: 768px) {
    padding-top: 5rem;
  }
`;


